<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="3">
        <div class="form-group">
          <label
                  for="clienttype_title"
                  class="form-control-label">{{ $t('global.title') }}:</label>
          <input
                  id="clienttype_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="3">
        <div class="form-group">
          <label
            for="clienttype_description"
            class="form-control-label">{{ $t('global.description') }}:</label>
          <input
            id="clienttype_description"
            v-model="item.description"
            :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
            type="text"
            required="false"
            placeholder=""
            @input="handleUpdateField('description', $event.target.value)">
          <div
            v-if="isInvalid('description')"
            class="invalid-feedback">{{ violations.description }}</div>
        </div>
      </b-col>
      <b-col cols="3">
        <div class="form-group">
          <label
            for="clienttype_roles"
            class="form-control-label">{{ $t('views.excmtasktype.form.role') }}:</label>
          <input
            id="clienttype_roles"
            v-model="item.roles[0]"
            :class="['form-control', isInvalid('role') ? 'is-invalid' : '']"
            type="text"
            required="true"
            placeholder=""
            @input="handleUpdateField('roles', $event.target.value)">
          <div
            v-if="isInvalid('roles')"
            class="invalid-feedback">{{ violations.roles }}</div>
        </div>
      </b-col>
      <b-col cols="3">
        <div class="form-group">
          <label
            for="clienttype_defaultRoute"
            class="form-control-label">{{ $t('views.clienttype.form.defaultRoute') }}:</label>
          <model-select :options="defaultRouteOptions" v-model="item.defaultRoute"></model-select>
          <div
            v-if="isInvalid('roles')"
            class="invalid-feedback">{{ violations.defaultRoute }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    ModelSelect
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      defaultRouteOptions: [
        { value: '/admin/timetable/dashboard', text: this.$t('views.clienttype.form.defaultRouteDashboard') },
        { value: '/admin/dashboard/client', text: this.$t('views.clienttype.form.defaultRouteClient') }
      ]
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
